
<div *ngIf="currentFact" [formGroup]="currentFact">
  <qai-accordian
    [title]="''"
    [isExpanded]="false"
    [optionButton]="optionButton"
  >
    <qai-icon
      accordianInput
      [kind]="'drag'"
      [color]="'#027b8c'"
      qaiDragHandle
      [size]="'16px'"
    ></qai-icon>

    <textarea
      accordianInput
      formControlName="rawText"
      qai-textarea
      qaiTrimLeading
      qaiPasteClean
      autosize
      [maxLines]="5"
      [placeholder]="'simulationBuilder.ENTER_MESSAGE_TEXT' | transloco"
    ></textarea>

    <qai-flex-container
      [direction]="'row'"
      [justifyContent]="'flex-start'"
      [flexWrap]="'wrap'"
      [gap]="'24px'"
      [alignItems]="'flex-start'"
      [background]="'transparent'"
      class="flex-container"
    >
      <qai-field
        class="threshold-col"
        [label]="'simulationBuilder.THRESHOLD' | transloco"
      >
        <div class="dropdown-container">
          <qai-floating-select
            [options]="thresholdOptions"
            [placeholder]="'simulationBuilder.SELECT_AN_OPTION' | transloco"
            [placement]="'below-start'"
            [offset]="4"
            [value]="threshold"
            [shape]="'rectangle'"
            [disabled]="readOnly"
            (valueChange)="valueChange($event, 1)"
            (selectionChange)="selectionChange($event)"
          ></qai-floating-select>
        </div>
      </qai-field>

      <qai-field
        class="type-col"
        [label]="'simulationBuilder.TYPE' | transloco"
      >
        <div class="dropdown-container">
          <qai-floating-select
            [options]="messageTypeOptions"
            [placeholder]="'simulationBuilder.SELECT_AN_OPTION' | transloco"
            [placement]="'below-start'"
            [offset]="4"
            [value]="messageType"
            [shape]="'rectangle'"
            [disabled]="true"
          ></qai-floating-select>
        </div>
      </qai-field>
    </qai-flex-container>

    <qai-item-grid
      [repeatCount]="'auto-fit'"
      [gap]="'24px'"
      [minItemWidth]="'300px'"
    >
      <qai-field [label]="'simulationBuilder.CORRECT_FEEDBACK' | transloco">
        <textarea
          formControlName="displayTextCorrect"
          qai-textarea
          qaiTrimLeading
          qaiPasteClean
          autosize
          [maxLines]="30"
          [placeholder]="
            'simulationBuilder.CORRECT_FEEDBACK_PLACEHOLDER' | transloco
          "
        ></textarea>
      </qai-field>

      <qai-field [label]="'simulationBuilder.INCORRECT_FEEDBACK' | transloco">
        <textarea
          formControlName="displayTextIncorrect"
          qai-textarea
          qaiTrimLeading
          qaiPasteClean
          autosize
          [maxLines]="30"
          [placeholder]="
            'simulationBuilder.INCORRECT_FEEDBACK_PLACEHOLDER' | transloco
          "
        ></textarea>
      </qai-field>
    </qai-item-grid>
  </qai-accordian>
</div>
